module.exports = __webpack_public_path__ + "static/media/infotip.9c8ea053.svg";